import imgTopLeft from "../assets/Frame 381.png"; 
import imgBottomRight from "../assets/Frame 383.png";
import googleImg from "../assets/image 1.png";
import appStoreImg from "../assets/image 2.png";

function WhatYouCanReport() {
  return (
    <section id="what-you-can-report" className="py-5 bg-white">
      <div className="container">
        <h2 className="text-center fw-bold">What You Can Report</h2>
        <p className="text-center text-muted mb-5">
          The app supports civic and emergency reporting across these areas:
        </p>

        <div className="row col-lg-9 mx-auto g-4">
          {/* Top left image */}
          <div className="col-md-7">
            <img
              src={imgTopLeft}
              alt="Broken road"
              className="img-fluid rounded-4 w-100"
              style={{ objectFit: "cover", height: "100%" }}
            />
          </div>

          {/* Civic Infrastructure list */}
          <div className="col-md-5">
            <div className="bg-success-subtle text-dark p-4 rounded-4 h-100">
              <h5 className="fw-bold text-success">
                Civic Infrastructure & Environment
              </h5>
              <ul className="mt-3">
                <li>Broken roads or dangerous potholes</li>
                <li>Damaged or missing manhole covers</li>
                <li>Faulty or fallen streetlights</li>
                <li>Overflowing or illegal waste dumps</li>
                <li>Blocked drainages and flood-prone areas</li>
                <li>Open or exposed power lines</li>
                <li>Fire hazards or minor fire outbreaks</li>
                <li>Unsafe construction or collapsed structures</li>
                <li>Water or power outages</li>
              </ul>
            </div>
          </div>

          {/* Accidents & Emergencies list */}
          <div className="col-md-5">
            <div className="bg-danger-subtle text-dark p-4 rounded-4 h-100">
              <h5 className="fw-bold text-danger">Accidents & Emergencies</h5>
              <ul className="mt-3">
                <li>
                  Road traffic <strong>accidents</strong> (minor or major)
                </li>
                <li>Building collapse or natural disasters</li>
                <li>Fire emergencies</li>
                <li>Medical emergencies</li>
                <li>Robbery, assault, or public unrest (non-live)</li>
                <li>Domestic violence or abuse</li>
                <li>Any public emergency needing urgent attention</li>
              </ul>

              {/* Store buttons */}
              <div className="d-flex gap-3 mt-4">
                <a href="https://play.google.com/">
                  <img src={googleImg} alt="Google Play" height="40" />
                </a>
                <a href="https://play.google.com/">
                  <img src={appStoreImg} alt="App Store" height="40" />
                </a>
              </div>
            </div>
          </div>

          {/* Bottom right image */}
          <div className="col-md-7">
            <img
              src={imgBottomRight}
              alt="Car accident"
              className="img-fluid rounded-4 w-100"
              style={{ objectFit: "cover", height: "100%" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhatYouCanReport;
